import React, { Fragment, useState } from "react";
import * as Icon from "@phosphor-icons/react";
import { toast, ToastContainer } from "react-toastify";

import { PasswordValidator } from "../../../_Auth/password-validator.js";

import { AppName, SsoIdBranding } from "../../../../Common/constants.js";

import "react-toastify/dist/ReactToastify.css";
import "./sso-account-create.css";
import "./../../../../../Styles/form.css";

const SsoAccountCreate = (props) => {
    const [idmkrUsername, setIdmkrUsername] = useState("");
    const [idmkrPassword, setIdmkrPassword] = useState("");
    const [newUsername, setNewUsername] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [emailAddress, setEmailAddress] = useState("");

    const [status, setStatus] = useState("");
    const [uiState, setUiState] = useState("");
    const [showConnectAccount, setShowConnectAccount] = useState({ shown: false });

    const validFields = async () => {
        let error = "";

        let passwordResult = { valid: true };
        const passwordValidator = await PasswordValidator.create();
        passwordResult = passwordValidator.validate(newPassword);

        if (idmkrUsername.trim() === "") {
            error = `Please enter your old ${AppName} username.`;
        }
        else if (idmkrPassword.trim() === "") {
            error = `Please enter your old ${AppName} password.`;
        }
        else if (newUsername.trim() === "") {
            error = `Please enter your new ${SsoIdBranding} username.`;
        }
        else if (newPassword.trim() === "") {
            error = `Please enter your new ${SsoIdBranding} password.`;
        }
        else if (!passwordResult.valid) {
            error = passwordResult.error;
        }
        else if (newPassword.trim() !== confirmPassword.trim()) {
            error = "The New Password and Confirm Password fields do not match.";
            isValid = false;
        }
        else if (firstName.trim() === "") {
            error = "Please enter your first name.";
        }
        else if (lastName.trim() === "") {
            error = "Please enter your last name.";
        }
        else if (emailAddress.trim() === "") {
            error = "Please enter your email address.";
        }

        if (error) {
            toast.error(error);
            setStatus(error);
            return false;
        }

        setStatus("");
        return true;
    };

    const create = async (e) => {
        e.preventDefault();
        setUiState("creatingAccount");

        if (!await validFields()) {
            setUiState("dataEntry");
            return;
        }

        const loginData = {
            idmkrUsername,
            idmkrPassword,
            newUsername,
            newPassword,
            firstName,
            lastName,
            emailAddress
        };

        fetch("/account/ssouser", {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            body: JSON.stringify(loginData)
        })
            .then(async (res) => {
                const data = await res.json();
                if (data.success) {
                    window.location.href = props.returnUrl;
                }
                else {
                    switch (data.errorCode) {
                        case "EMAIL_EXISTS":
                            setShowConnectAccount({ shown: true });
                            break;

                        default:
                            toast.error(data.errorMessage);
                            setStatus(data.errorMessage);
                            break;
                    }
                }
            })
            .catch(() => {
                toast.error("A problem during log in has occurred. Please try again.");
                setStatus("A problem during log in has occurred. Please try again.");
            })
            .finally(() => {
                setUiState("dataEntry");
            });
    };

    function openConnectAccount() {
        setShowConnectAccount({ shown: true });
    }

    function closeConnectAccount() {
        setShowConnectAccount({ shown: false });
    }

    function tryLogInOrConnect() {
        fetch(`/account/generatessourl?redirectafterlogIn=/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            }
        })
            .then(async (res) => {
                if (res.ok)
                    return await res.json();
            })
            .then((data) => {
                window.location.href = data.url;
            })
            .catch((err) => {
                console.error("Login error:", err);
            });
    }

    return (
        <Fragment>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar
                toastStyle={{
                    borderRadius: "0.375rem",
                    textAlign: "left",
                    minWidth: "320px",
                    fontSize: "14px"
                }}
            />

            <div styleName="login-welcome-msg">
                <div styleName="msg">Create your new {SsoIdBranding} <Icon.IdentificationBadge styleName="id-icon" color="#ffb200" weight="fill" size={20} /></div>
            </div>

            <form>
                <div styleName="section-lbl">Old Account Details<span styleName="asterisk">*</span></div>
                <hr/>
                <input type="text" styleName="login-form__input-text" value={idmkrUsername} onChange={(e) => setIdmkrUsername(e.target.value)} id="ossUsername" name="ossUsername" placeholder="ID Maker Username" autoFocus required disabled={uiState === "creatingAccount"} />
                <input type="password" styleName="login-form__input-text" value={idmkrPassword} onChange={(e) => setIdmkrPassword(e.target.value)} name="ossPassword" placeholder="ID Maker Password" required disabled={uiState === "creatingAccount"} />
                <div styleName="section-lbl">New Account Details<span styleName="asterisk">*</span></div>
                <hr/>
                <input type="text" styleName="login-form__input-text" value={newUsername} onChange={(e) => setNewUsername(e.target.value)} id="username" name="newUsername" placeholder="New Username" required disabled={uiState === "creatingAccount"} />
                <input type="password" styleName="login-form__input-text" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} name="newPassword" placeholder="New Password" required disabled={uiState === "creatingAccount"} />
                <input type="password" styleName="login-form__input-text" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} name="confirmPassword" placeholder="Confirm Password" required disabled={uiState === "creatingAccount"} />
                <input type="text" styleName="login-form__input-text" value={firstName} onChange={(e) => setFirstName(e.target.value)} name="firstName" placeholder="First Name" required disabled={uiState === "creatingAccount"} />
                <input type="text" styleName="login-form__input-text" value={lastName} onChange={(e) => setLastName(e.target.value)} name="lastName" placeholder="Last Name" required disabled={uiState === "creatingAccount"} />
                <input type="email" styleName="login-form__input-text" value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} name="emailAddress" placeholder="Email Address" required disabled={uiState === "creatingAccount"} />

                <button type="submit" styleName="login-form__button login-form__button--highlight" onClick={create} disabled={uiState === "creatingAccount"}>
                    Create
                </button>
                <button type="button" styleName="login-form__button cancel-button" onClick={props.cancel} disabled={uiState === "creatingAccount"}>
                    Cancel
                </button>
            </form>

            {
                showConnectAccount.shown &&
                <div styleName="modal-overlay">
                        <div styleName="modal-form modal-form-main-container">
                            <h2 styleName="modal-form__title">Email already exists</h2>
                            <div>
                                <div styleName="modal-form-container-section">
                                    The email address you specified already exists. Would you like to log in or connect it to your {AppName} account instead?
                                </div>

                            </div>

                            <div styleName="modal-form__btn-container">
                                <button type="button" styleName="modal-form__ok-btn" onClick={tryLogInOrConnect} tabIndex="0">Connect</button>
                                <button type="button" styleName="modal-form__cancel-btn" id="cancel" onClick={closeConnectAccount} tabIndex="0">Cancel</button>
                            </div>
                        </div>
                </div>
            }
        </Fragment>
    );
};

export default SsoAccountCreate;